import React, { useState, useEffect } from 'react';
import { FiBell, FiHome, FiOctagon } from 'react-icons/fi';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from "react-redux";
// Định nghĩa một React component
import { Cookies } from './../index.js';
import { get_latest_version_text } from '../js/latest_version.js';
import { isLocalHost } from '../shared/host_utils.js';

const Footer = () => {
    const [chedo, setchedo] = useState('');
    const latest_version = useSelector(state => state.latest_version);
    const latestVersionFromCookieRaw = get_latest_version_text(Cookies.get('latest_version'));
    const resolvedLatestVersion =
        latest_version !== false &&
        latest_version !== '' &&
        latest_version !== null &&
        latest_version !== undefined
            ? get_latest_version_text(latest_version)
            : latestVersionFromCookieRaw;
    const hasResolvedLatestVersion = resolvedLatestVersion !== '';
    const main_domain = Cookies.get("main_domain");
    const myCookieValue = Cookies.get('apikey');

    // Lấy tham số 'chedo' từ URL khi component mount hoặc URL thay đổi
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const chedoValue = url.searchParams.get('chedo');

    useEffect(() => {
        if (chedoValue && chedo !== chedoValue) {
            setchedo(chedoValue);
        }
    }, [chedoValue, chedo]);

    const navigate = useNavigate();
    const switch_router = (link) => {
        const national_market = Cookies.get('national_market');

        if (myCookieValue && national_market && main_domain && (window.location.hostname === 'hust.media' || window.location.hostname === 'tecom.pro')) {
            const base = 'https://tecom.pro';
            const target = new URL(link, base); // tự động ghép base + path

            // thêm apikey vào query params
            target.searchParams.set('apikey', myCookieValue);
            target.searchParams.set('national_market', national_market);
            target.searchParams.set('main_domain', main_domain);
            // chuyển hướng
            window.location.href = target.toString();
        } else {
            navigate(link);
        }
    }
    const userAgent = navigator.userAgent.toLowerCase();

    const shouldHideFooterAppForVersion =
        !myCookieValue &&
        (resolvedLatestVersion == '2' || resolvedLatestVersion == '3');
    const shouldHideWhileResolving = !myCookieValue && !hasResolvedLatestVersion;

    if (shouldHideWhileResolving || shouldHideFooterAppForVersion) {
        return null;
    }

    return (
        <>
            {chedo !== 'native' && (
                <div>
                    {(((!isLocalHost(window.location.hostname)) && (Cookies.get("main_domain") == 'hust')) ||
                        userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android"))
                        ? (
                            <>
                                <div className="py-4"></div>
                                <div className="max-w-md mx-auto fixed bottom-0 left-0 right-0">
                                    <div className="bg-white mx-10 shadow-md rounded-3xl mb-2">
                                        <div className="py-2 flex justify-around">
                                            <a href="/reactapp/" className="text-gray-800 hover:text-gray-600">
                                                <FiHome className="mt-0.5" size={20} />
                                            </a>
                                            <a onClick={() => switch_router('/shop/main/menu?webappmode=showadview')} className="text-gray-800 hover:text-gray-600">
                                                <FiOctagon className="mt-0.5" size={19} />
                                            </a>
                                            <div onClick={() => switch_router('/shop/history/home?webappmode=showadview')} className="text-gray-800 hover:text-gray-600">
                                                <FiBell className="mt-0.5" size={20} />
                                            </div>
                                            <a href="/shop/profiles/home" className="text-gray-800 hover:text-gray-600">
                                                👩🏻‍🦰
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="py-4"></div>
                                <div className="max-w-md mx-auto fixed bottom-0 left-0 right-0">
                                    <div className="bg-white mx-10 shadow-md rounded-3xl mb-2">
                                        <div className="py-2 flex justify-around">
                                            <Link to="/reactapp" className="text-gray-800 hover:text-gray-600">
                                                <FiHome className="mt-0.5" size={20} />
                                            </Link>
                                            <Link to="/shop/history/home" className="text-gray-800 hover:text-gray-600">
                                                <FiBell className="mt-0.5" size={20} />
                                            </Link>
                                            <Link to="/shop/profiles/home?webappmode=showadview" className="text-gray-800 hover:text-gray-600">
                                                👩🏻‍🦰
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
            )}
        </>
    );
};

export default Footer;
